export const useVideoAutoplay = () => {
  const isLowPowerMode = ref(false);

  const checkLowPowerMode = async (videoElement) => {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (!isIOS || !videoElement) {
      isLowPowerMode.value = false;
      return;
    }

    const wasPaused = videoElement.paused;
    const currentTime = videoElement.currentTime;

    try {
      await videoElement.play();
      isLowPowerMode.value = false;

      if (wasPaused) {
        videoElement.pause();
        videoElement.currentTime = currentTime;
      }
    } catch (error) {
      isLowPowerMode.value = true;
      console.warn('Low power mode detected in iOS:', error);
    }
  };

  const playVideoOnTouch = (videoElement) => () => {
    if (videoElement && videoElement.paused) {
      videoElement.play().catch((error) => {
        console.error('Failed to play video:', error);
      });
    }
  };

  const setupVideoAutoplay = async (videoRef) => {
    if (!process.client || !videoRef.value) return;

    await checkLowPowerMode(videoRef.value);

    const touchHandler = playVideoOnTouch(videoRef.value);

    if (isLowPowerMode.value) {
      document.addEventListener('touchstart', touchHandler, {
        passive: true,
      });
    }

    const cleanup = () => {
      document.removeEventListener('touchstart', touchHandler);
    };

    onBeforeUnmount(cleanup);

    return cleanup;
  };

  const onVideoError = (videoRef) => () => {
    if (process.client && videoRef.value) {
      console.warn(
        'Video play failed. Trying to play video on touchstart event.',
      );

      const touchHandler = playVideoOnTouch(videoRef.value);
      document.addEventListener('touchstart', touchHandler, {
        passive: true,
      });
    }
  };

  return {
    isLowPowerMode: readonly(isLowPowerMode),
    setupVideoAutoplay,
    onVideoError,
  };
};
